import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import {flushErrorBuffer, trackError, trackPerformance} from "./actions";
import {ErrorActions, IErrorState, LogLevel} from "./types";
import {errorMatcher, FAILURE_POSTFIX} from "../common/types";
import {exportStateFlow} from "../common/stateFlowEnhancer";

const LOG_APP_STATE_FROM_LEVEL = LogLevel.Error;

export const logInitialState: IErrorState = {
    errors: [],
    metrics: [],
};

export const logReducer : Reducer<IErrorState, ErrorActions> = (state = logInitialState, action) => {
    switch (action.type) {
        case (getType(trackPerformance)):
            if (window.DISABLE_PERFORMANCE_TRACKING)
                return state;

            return {
                ...state,
                metrics: [
                    ...state.metrics,
                    {
                        logLevel: LogLevel.Debug,
                        category: action.payload.category,
                        action: action.payload.action,
                        start: action.payload.start,
                        end: action.payload.end,
                        duration: action.payload.end - action.payload.start,
                    }
                ]
            };

        case (getType(trackError)):
            if (window.DISABLE_ERROR_LOGGING)
                return state;

            const error = action.payload.error
                && Object.getOwnPropertyNames(action.payload.error).reduce((acc, key) => ({
                    ...acc,
                    [key]: action.payload.error[key]
                }), {}) as Record<string, any>;

            return {
                ...state,
                errors: [
                    ...state.errors,
                    {
                        logLevel: action.payload.logLevel || LogLevel.Error,
                        category: action.payload.category,
                        message: action.payload.message,
                        stack: error && error.stack,
                        data: {
                            clientTime: new Date().toISOString(),
                            error,
                            state: action.payload.logLevel >= LOG_APP_STATE_FROM_LEVEL
                                ? exportStateFlow()
                                : undefined,
                            ...action.payload.data,
                        },
                    }
                ]
            };

        case (getType(flushErrorBuffer)):
            return {
                ...state,
                errors: [],
                metrics: [],
            };

        default:
            const { type, payload } = action;
            const matches = errorMatcher.exec(type);

            if (!matches) {
                return state;
            }

            const [, requestName, requestState] = matches;
            return {
                ...state,
                [requestName]: requestState === FAILURE_POSTFIX
                    ? payload.message
                    : undefined
            };
    }
};
